import type { CostBreakdownProductsFormValues } from "../schemas"

import type { GoodsReceipt, Product, ProductWarehouseArea } from "@/graphql/codegen/graphql"
import { getGoodsReceiptPurchaseOrderLines } from "@/screens/WarehouseReceiving/utils"

const hasProductWarehouseAssociation = (
  warehouseAreas: Pick<ProductWarehouseArea, "warehouseAreaId" | "isActive">[] | null | undefined,
  warehouseAreaId: string
): boolean =>
  !!warehouseAreas?.some((warehouseArea) => warehouseArea.warehouseAreaId === warehouseAreaId && warehouseArea.isActive)

export const filterProductsWithoutWarehouseAssociation = (
  goodsReceipt: GoodsReceipt,
  productCostBreakdowns: CostBreakdownProductsFormValues["products"]
): Product[] => {
  const warehouseAreaId = goodsReceipt.warehouseArea?.warehouseAreaId

  if (!warehouseAreaId) return []

  const purchaseOrderLines = getGoodsReceiptPurchaseOrderLines(goodsReceipt)

  return productCostBreakdowns
    .map((productCostBreakdown, index) =>
      productCostBreakdown.isCompleted ? purchaseOrderLines[index]?.product : undefined
    )
    .filter(
      (product): product is Product =>
        !!product && !hasProductWarehouseAssociation(product.warehouseAreas, warehouseAreaId)
    )
}
